import React, { useState, useRef, useEffect } from 'react';
import { LoremIpsum, Avatar } from 'react-lorem-ipsum';
import {  Faker, allFakers } from '@faker-js/faker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faRefresh } from '@fortawesome/free-solid-svg-icons';
import Editor from '@monaco-editor/react';
const { format, set } = require('date-fns');

const defaultComponentProps = {
  p: 1,
  avgWordsPerSentence: 8,
  avgSentencesPerParagraph: 8,
  startWithLoremIpsum: true,
  random: true,
};

const listAvailableLocales = [
  'en', 'de', 'de_AT', 'de_CH', 'el', 'en_AU', 'en_CA', 'en_GB', 'en_HK', 'en_IE',
  'en_IN', 'en_US', 'en_ZA', 'es', 'es_MX', 'fr', 'it', 'ja', 'id_ID', 'ko', 'nl', 'ru',
  'sv', 'th', 'tr', 'uk', 'zh_CN', 'zh_TW', 'vi'
]

const LoremIpsumPage = (props) => {
  const { randomType, editorTheme } = props
  const [componentProps, setComponentProps] = useState(defaultComponentProps);
  const [key, setKey] = useState(1);
  const [currentLocale, setCurrentLocale] = useState('en')
  const [jsonOutput, setJsonOutput] = useState('')

  const createRandomUser = () => {
    // const fakerN =  new Faker({
    //   locale: [vi, de_CH, de, en, base],
    // });
    const fakerN = allFakers[currentLocale]
    return {
      _id: fakerN.string.uuid(),
      avatar: fakerN.image.avatar(),
      birthday: fakerN.date.birthdate(),
      email: fakerN.internet.email(),
      // firstName: faker.person.firstName(),
      // lastName: faker.person.lastName(),
      fullname: fakerN.person.fullName(),
      sex: fakerN.person.sexType(),
      username: fakerN.internet.userName(),
      bio: fakerN.person.bio(),
      jobTitle: fakerN.person.jobTitle(),
      jobType: fakerN.person.jobType(),
      jobDescriptor: fakerN.person.jobDescriptor(),
      phoneNumner: fakerN.phone.number(),
      subscriptionTier: fakerN.helpers.arrayElement(['free', 'basic', 'business']),
    };
  }

  const [randUser, setRandUser] = useState(createRandomUser())

  const outputRef = useRef(null)

  const handleComponentPropsChange = e => {
    const { type, name, value, checked } = e.target;
    const { [name]: v, ...others } = componentProps;
    setComponentProps({ [name]: type === 'checkbox' ? checked : parseInt(value, 10), ...others });
  };

  const resetComponentProps = () => {
    setComponentProps(defaultComponentProps);
  };

  const handleCopy = () => {
    const text = outputRef.current.textContent
    navigator.clipboard.writeText(text);
  }

  const onShuffle = () => {
    setKey(key + 1);
    const newRandUser = createRandomUser();
    setRandUser(newRandUser);
    setJsonOutput(JSON.stringify(newRandUser, null, 2))
  };

  const camelCaseToTitleCase = (str) => {
    // Split the camelCase string into words
    const words = str.replace(/([A-Z])/g, ' $1').trim();
  
    // Capitalize the first letter of each word
    const titleCased = words
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  
    return titleCased;
  }
  
  useEffect(() => {
    if (currentLocale) {
      const newRandUser = createRandomUser();
      setRandUser(newRandUser);
      setJsonOutput(JSON.stringify(newRandUser, null, 2))
    }
  }, [currentLocale])

  const renderRandomPerson = () => {
    return (
      <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4" key={key}>
        <div className="col-span-2">
          <div className="p-4 mb-4 space-y-6 bg-white border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
            <div className="px-4 py-2 font-medium text-md dark:border-gray-600">
              <div className="col-span-2 grid grid-cols-3 xl:grid-cols-3 xl:gap-4">
                <div class="items-center">
                  <select
                    onChange={(e) => setCurrentLocale(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  >
                    { listAvailableLocales.map((locale, index) => {
                      return (<option selected={currentLocale === locale} value={locale}>{locale}</option>)
                    }) }
                  </select>
                </div>
                <div class="items-center">
                  <button
                    onClick={onShuffle}
                    type="button"
                    className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                  >
                    <FontAwesomeIcon icon={faRefresh}/>
                    &nbsp; SHUFFLE USER
                  </button>
                </div>
              </div>
            </div>
            <div className="px-4 py-2 font-medium text-md rounded dark:border-gray-600">
              <div className="col-span-2 grid grid-cols-3 xl:grid-cols-3 xl:gap-4">
                <div class="items-center">
                  <Avatar gender={randUser.sex} width="200" height="200" alt="Avatar" />
                  <p className='mb-3 mt-3 text-gray-500 dark:text-gray-400'>
                    <h4 className="text-2xl font-bold dark:text-white">{randUser.fullname}</h4>
                    <span>{`@${randUser.username}`}</span>
                  </p>
                </div>
                <div class="flex">
                  <table className="w-full text-md text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <tbody>
                      { Object.keys(randUser).map((k, idex) => {
                        if (['_id', 'avatar'].includes(k)) {
                          return <div/>
                        }
                        return (
                          <tr id={`row-info-${idex}`} key={`row-info-${idex}`} class="bg-white dark:bg-gray-800">
                            <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              { camelCaseToTitleCase(k) }
                            </th>
                            <td class="px-6 py-4">
                              { typeof randUser[k] !== 'object' && randUser[k] }
                              { typeof randUser[k] === 'object' && format(randUser[k], 'yyyy-MM-dd') }
                            </td>
                          </tr>
                        )
                      }) }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-span-2 xl:col-auto">
          <div className="p-4 mb-4 space-y-6 bg-white border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
            <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
              <h3 className='uppercase border-l-4 border-blue-600 p-2'>JSON</h3>
            </div>
            <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
              <Editor
                language='json'
                height="66vh"
                theme={editorTheme}
                value={jsonOutput}
                className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              />
            </div>
          </div>
        </div> */}
      </div>
    )
  }

  const renderRandomText = () =>{
    return (
      <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
        <div className="col-span-2">
          <div  className="p-4 mb-4 space-y-6 bg-white border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
            <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
              <h3 className='uppercase border-l-4 border-blue-600 p-2'>Your customize</h3>
            </div>
            <div className="px-4 py-2 rounded">
              <div className="col-span-2 grid grid-cols-6 xl:grid-cols-6 xl:gap-4">
                <div class="flex items-center">
                  <label for="default-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    {`Paragraph Count (${componentProps.p})`}
                  </label>
                  <input
                    min="1" max="50"
                    name="p"
                    onChange={handleComponentPropsChange}
                    id="default-range" type="range" value={componentProps.p}
                    class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                  />
                </div>
                <div class="flex items-center">
                  <label for="default-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    {`Average Words Per Sentence (${componentProps.avgWordsPerSentence})`}
                  </label>
                  <input
                    min="4" max="20"
                    name="avgWordsPerSentence"
                    onChange={handleComponentPropsChange}
                    id="default-range" type="range" value={componentProps.avgWordsPerSentence}
                    class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                  />
                </div>
                <div class="flex items-center">
                  <label for="default-range" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    {`Average Sentences Per Paragraph (${componentProps.avgSentencesPerParagraph})`}
                  </label>
                  <input
                    min="4" max="20"
                    name="avgSentencesPerParagraph"
                    onChange={handleComponentPropsChange}
                    id="default-range" type="range" value={componentProps.avgSentencesPerParagraph}
                    class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                  />
                </div>
                <div class="flex items-center">
                  <input name="startWithLoremIpsum" onChange={handleComponentPropsChange} checked={componentProps.startWithLoremIpsum} id="checked-checkbox-3" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                  <label for="checked-checkbox-3" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    Start with “Lorem ipsum odor amet, ...”
                  </label>
                </div>
                <div class="flex items-center">
                  <input name="random" onChange={handleComponentPropsChange} checked={componentProps.random} id="checked-checkbox-1" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                  <label for="checked-checkbox-1" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    Random
                  </label>
                </div>
                <div class="flex items-center">
                  <button
                    onClick={resetComponentProps}
                    type="button"
                    className="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                  >
                    <FontAwesomeIcon icon={faRefresh}/>
                    &nbsp; Reset to default
                  </button>
                </div>
              </div>
            </div>
            <div className="px-4 py-2 font-medium text-md border border-gray-200 border-dashed rounded dark:border-gray-600">
              <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Result</h3>
            </div>
            <div ref={outputRef} className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
              <LoremIpsum
                p={componentProps.p}
                avgWordsPerSentence={componentProps.avgWordsPerSentence}
                avgSentencesPerParagraph={componentProps.avgSentencesPerParagraph}
                startWithLoremIpsum={componentProps.startWithLoremIpsum}
                random={componentProps.random}
              />
            </div>
            <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
              <button
                type="button"
                onClick={handleCopy}
                className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
              >
                <FontAwesomeIcon icon={faCopy}/>
                &nbsp; Copy
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
   <>
    { randomType === 'randomPerson' && renderRandomPerson() }
    { randomType !== 'randomPerson' && renderRandomText() }
   </>
  )
}

export default LoremIpsumPage;
